<template>
  <div>
    <div
      class="hamburger"
      :class="{ 'is-active': isMenuOpen }"
      @click="toggleMenu"
    >
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>

    <transition name="fade">
      <div v-if="isMenuOpen" class="backdrop" @click="closeMenu"></div>
    </transition>

    <div :class="['menu-drawer', { 'menu-open': isMenuOpen }]">
      <div class="menu-header">
        <h3 class="menu-title">NAVIGACE</h3>
      </div>

      <nav>
        <ul class="menu-list">
          <li @click="navigateTo('tipForm')" class="menu-item">
            <svg
              class="menu-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
              <path d="M2 12h20"></path>
              <path d="M12 12l4.9 4.9"></path>
              <path d="M12 12l-4.9 4.9"></path>
            </svg>
            <span>Tipování</span>
          </li>

          <li @click="navigateTo('leaderboard')" class="menu-item">
            <svg
              class="menu-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path
                d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"
              ></path>
              <path
                d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"
              ></path>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
            </svg>
            <span>Žebříček</span>
          </li>

          <li @click="navigateTo('statistics')" class="menu-item">
            <svg
              class="menu-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="20" x2="18" y2="10"></line>
              <line x1="12" y1="20" x2="12" y2="4"></line>
              <line x1="6" y1="20" x2="6" y2="14"></line>
            </svg>
            <span>Statistiky</span>
          </li>

          <li @click="navigateTo('chat')" class="menu-item">
            <svg
              class="menu-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              ></path>
            </svg>
            <span>Chat</span>
          </li>

          <li @click="navigateTo('settings')" class="menu-item">
            <svg
              class="menu-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <path
                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
              ></path>
            </svg>
            <span>Nastavení</span>
          </li>
        </ul>
      </nav>

      <div class="menu-footer">
        <span class="footer-text">© 2026 PRASO LIGA</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HamburgerMenu",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    navigateTo(view) {
      this.$emit("navigate", view);
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
/* ========================
   HAMBURGER TLAČÍTKO
   ======================== */
.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 35px;
  height: 24px;
  cursor: pointer;
  position: fixed;
  top: 25px;
  left: 25px;
  z-index: 2000;
  transition: transform 0.3s ease-in-out;
}

.hamburger .line {
  width: 100%;
  height: 3px;
  background-color: #fff;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
  transform-origin: left;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5); /* Lepší viditelnost */
}

.hamburger:hover .line {
  background-color: var(--primary-red, #dc3545);
}

.hamburger.is-active .line:nth-child(1) {
  transform: rotate(45deg);
}

.hamburger.is-active .line:nth-child(2) {
  opacity: 0;
  transform: translateX(-10px);
}

.hamburger.is-active .line:nth-child(3) {
  transform: rotate(-45deg);
}

/* ========================
   BACKDROP
   ======================= */
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1500;
  backdrop-filter: blur(5px);
}

/* ========================
   MENU DRAWER
   ======================= */
.menu-drawer {
  position: fixed;
  left: -280px;
  top: 0;
  width: 260px;
  height: 100vh;
  background-color: #000; /* Čistě černá */
  border-right: 1px solid #333;
  box-shadow: 5px 0 20px rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  padding: 80px 20px 20px 20px;
  color: white;
  transition: transform 0.3s cubic-bezier(0.77, 0.2, 0.05, 1);
  z-index: 1600;
}

.menu-open {
  transform: translateX(280px);
}

/* Hlavička */
.menu-header {
  margin-bottom: 30px;
  border-bottom: 2px solid var(--primary-red, #dc3545);
  padding-bottom: 10px;
}

.menu-title {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
  margin: 0;
}

/* Položky */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}

.menu-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #bbb;
}

.menu-item span {
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Ikony */
.menu-icon {
  width: 22px;
  height: 22px;
  margin-right: 15px;
  stroke: #bbb;
  transition: stroke 0.2s ease;
}

/* Hover Efekty */
.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
  transform: translateX(5px);
  border-left: 3px solid var(--primary-red, #dc3545);
}

.menu-item:hover .menu-icon {
  stroke: var(--primary-red, #dc3545);
}

/* Patička */
.menu-footer {
  margin-top: auto;
  text-align: center;
  border-top: 1px solid #222;
  padding-top: 20px;
}

.footer-text {
  font-size: 0.7rem;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Animace */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
